import { ReactNode } from 'react';
import {
  Dialog,
  DialogBody,
  DialogHeader,
  DialogFooter,
  Button,
} from '@backstage/ui';

interface CustomDialogProps {
  isOpen: boolean;
  title: string;
  submitButtonText: string;
  /**
   * When set, renders a secondary button that closes the dialog.
   */
  cancelButtonText?: string;
  styles?: any;
  children?: ReactNode;
  onClose: () => void;
  onSubmit: () => void;
}

export function CustomDialog(props: Readonly<CustomDialogProps>) {
  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      props.onClose();
    }
  };

  return (
    <Dialog
      // className={props.styles}
      isOpen={props.isOpen}
      onOpenChange={handleOpenChange}
    >
      <DialogHeader>{props.title}</DialogHeader>
      {props.children && <DialogBody>{props.children}</DialogBody>}
      <DialogFooter>
        {props.cancelButtonText && (
          <Button variant="secondary" type="button" onClick={props.onClose}>
            {props.cancelButtonText}
          </Button>
        )}
        <Button variant="primary" type="button" onClick={props.onSubmit}>
          {props.submitButtonText}
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
